export * from './school-profile'
